module.exports = __webpack_public_path__ + "img/chara_line_5_white.2b1ebff4.png";